import { useEffect } from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useTaxYearOptional } from '@/contexts/TaxYearContext';

/**
 * Year dropdown for the user app. Renders nothing when not inside TaxYearProvider (e.g. admin layout).
 */
export function TaxYearSelector() {
  const taxYear = useTaxYearOptional();
  if (!taxYear || taxYear.isLoading || taxYear.availableYears.length === 0) {
    return null;
  }

  const availableYears = taxYear.availableYears;
  const selectedYear = taxYear.selectedYear;
  const valueInList = availableYears.includes(selectedYear);
  const displayValue = valueInList ? selectedYear : (taxYear.defaultYear ?? availableYears[0]);

  useEffect(() => {
    if (!valueInList) {
      taxYear.setSelectedYear(displayValue);
    }
  }, [valueInList, displayValue, taxYear.setSelectedYear]);

  return (
    <Select
      key={displayValue}
      value={String(displayValue)}
      onValueChange={(v) => taxYear.setSelectedYear(Number(v))}
    >
      <SelectTrigger className="w-[100px] h-9">
        <SelectValue placeholder="Year" />
      </SelectTrigger>
      <SelectContent>
        {availableYears.map((year) => (
          <SelectItem key={year} value={String(year)}>
            {year}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
